(function () {
  "use strict";

  const QUIZ_VERSION = "2026-08-restart-1";
  // Per-service Zenoti deep links (from client's Service Deeplinks CSV, 2026-07).
  const ZENOTI_SVC = 'https://toula.zenoti.com/webstoreNew/dff4e9d7-f3e8-4dda-81d5-8d6bfa024441?serviceid=';
  const BOOK_LINKS = {
    express:              ZENOTI_SVC + '0F56D079-4107-48B1-A094-5D249AB48952',
    'sensitive-facial':   ZENOTI_SVC + 'FD174466-537A-44A8-8CAC-C1FE7C662A5B',
    'clarifying-facial':  ZENOTI_SVC + 'ABEFAEB1-7350-4CBD-93C7-0CF3407B9564',
    'hydrating-facial':   ZENOTI_SVC + '33A19B14-AB26-400E-9588-F3957AF2CD0A',
    'brightening-facial': ZENOTI_SVC + '637982BE-546C-4DC5-B3F1-D6D37D741B5F',
    'anti-aging-facial':  ZENOTI_SVC + '210A562C-40F4-4F78-AE8B-F31D552A476F',
    'regenerative-facial':ZENOTI_SVC + '322941AC-E3EF-486F-8D29-C7E8F35ADAAD',
    microneedling:        ZENOTI_SVC + '11A8F2E4-1BD0-471D-BAB8-E05DEB98A17B', // New Client Microneedling Intro (M100)
    botox:                ZENOTI_SVC + 'F24A113D-C2CA-4011-B78F-2313A2DFD2E2',
    filler:               ZENOTI_SVC + 'A747A88E-6A06-438B-9CDD-91D95C847FE4', // Injectables Consultation (S003)
    sculptra:             ZENOTI_SVC + '83BB3E35-C7EE-4C91-BD6C-6733DE2206B1',
    injectablesConsult:   ZENOTI_SVC + 'A747A88E-6A06-438B-9CDD-91D95C847FE4', // Injectables Consultation (S003)
    led:                  ZENOTI_SVC + '40C7530C-5632-4B0D-B63E-E4D06934891F', // LED Light Therapy (S017)
    skinAnalysis:         ZENOTI_SVC + 'C1F83D21-BF56-4A57-A73E-F09B421F76AE', // Comprehensive Skin Analysis (S004)
    signature:            ZENOTI_SVC + '648B0E0B-7684-4EF4-8E12-1FB675B567CC', // The Signature Facial
  };
  // Book Now target per treatment. Clinical uncertainty uses Skin Analysis in renderResult.
  const TREATMENT_BOOK = {
    express: BOOK_LINKS.express,
    'sensitive-facial': BOOK_LINKS['sensitive-facial'],
    'clarifying-facial': BOOK_LINKS['clarifying-facial'],
    'hydrating-facial': BOOK_LINKS['hydrating-facial'],
    'brightening-facial': BOOK_LINKS['brightening-facial'],
    'anti-aging-facial': BOOK_LINKS['anti-aging-facial'],
    'regenerative-facial': BOOK_LINKS['regenerative-facial'],
    microneedling: BOOK_LINKS.microneedling,
    botox: BOOK_LINKS.botox,
    filler: BOOK_LINKS.filler,
    sculptra: BOOK_LINKS.sculptra,
    signature: BOOK_LINKS.signature,
  };
  const DEFAULT_MEMBERSHIP_URL = "/pages/our-memberships";
  const ADVANCE_DELAY = 420;

  // ── Image helpers ───────────────────────────────────────────────────
  const TOULA_FILES = 'https://toulastudio.com/cdn/shop/files/';
  const TOULA_ARTICLES = 'https://toulastudio.com/cdn/shop/articles/';
  const tFile = (slug, w) => `${TOULA_FILES}${slug}${w ? `?width=${w}` : ''}`;
  const tArticle = (slug, w) => `${TOULA_ARTICLES}${slug}${w ? `?width=${w}` : ''}`;
  // ── Welcome assets ──────────────────────────────────────────────────
  const WELCOME_AMBIENT = tFile('572442_TOULA_reception_V5.f_1.jpg', 1800);
  const TOULA_LOGO = tFile('TOULA_Gold_Logo.png', 600);
  // Used by the microneedling add-on/consult block on the result page.
  const MICRONEEDLING_HERO = tFile('microneedling.jpg', 1600);
  // Q3 (comfort) microneedling option card image — a device close-up.
  const DP4_DEVICE = tFile('TOULA_-_Facial_Treatment_Services_60.jpg', 1600);
  // Care Team block — a premium TOULA studio interior (reception/retail). Collective,
  // never a single-person headshot, and deliberately NOT any treatment hero (the site
  // has no group-at-work photo, so we use the space rather than duplicate a hero).
  const TEAM_IMAGE = tFile('E8A1363-HDR_a226c031-eccb-4ea7-9565-c27333738fe9.jpg', 1600);
  // Image library — every hero verified by crawling the matching
  // toulastudio.com/pages/<treatment> page. No icons, no syringe imagery,
  // no IG-import accent files.
  const IMG = {
      // Every hero is the actual treatment photo from the matching toulastudio.com
      // /pages/<service> page ("What to Expect" section) — real TOULA photography,
      // no stock beauty portraits, no duplicate reuse. Crawled 2026-07.
      led: tFile('red_light_therapy_chair.webp', 1600),
      expressHero: tFile('Express_Facial_-_Hydration_Recharge.jpg', 1600),
      sensitiveHero: tFile('Facial_for_Skin_Barrier_Repair.gif', 1600),
      clarifyingHero: tFile('facial_lympathic_drainage.jpg', 1600),
      hydratingHero: tFile('TOULA_-_Facial_Treatment_Services_74.jpg', 1600),
      brighteningHero: tFile('TOULA_-_Facial_Treatment_Services_59_805fcbb9-7d71-4aa1-a003-f5670e69660b.jpg', 1600),
      antiAgingHero: tFile('TOULA_-_Facial_Treatment_Services_76.jpg', 1600),
      regenerativeHero: tFile('TOULA_-_Facial_Treatment_Services_61_5ee15d1a-0a77-489c-8432-2fbffd835717.jpg', 1600),
      microneedlingHero: tFile('microneedling.jpg', 1600),
      botoxHero: tFile('15_9b26c772-4ef4-4c10-9a66-f404dac69539.jpg', 1600),
      fillerHero: tFile('dermafiller.webp', 1600),
      sculptraHero: tFile('TOULA_-_Facial_Treatment_Services_1.jpg', 1600),
  };
  // ── Questions ───────────────────────────────────────────────────────
  const QUESTIONS = [
      {
          id: 'firsttime',
          eyebrow: 'Question 01',
          prompt: 'Is this your first time visiting TOULA?',
          helper: 'It helps us tailor your very first visit.',
          options: [
              {
                  id: 'yes',
                  label: 'Yes, my first visit',
                  hint: 'New to TOULA',
                  flavor: 'Where the whole plan begins.',
              },
              {
                  id: 'returning',
                  label: "No, I've been before",
                  hint: 'A returning guest',
                  flavor: 'Picking up where you left off.',
              },
          ],
      },
      {
          id: 'concern',
          eyebrow: 'Question 02',
          prompt: 'What are your current skin concerns?',
          helper: 'Pick the one you’d tackle first.',
          options: [
              {
                  id: 'lines',
                  label: 'Fine lines & wrinkles',
                  hint: 'Around the eyes, forehead, or mouth',
                  flavor: 'The first signs of expression.',
                  details: 'Static lines that are visible at rest, or dynamic lines that appear with expression. Most respond to a combination of wrinkle relaxers and resurfacing treatments over time.',
              },
              {
                  id: 'texture',
                  label: 'Texture & pores',
                  hint: 'Rough patches, large pores, scars',
                  flavor: 'What the skin\u2019s surface remembers.',
                  details: 'Uneven surface from sun damage, post-acne scarring, or genetic pore size. Microneedling and resurfacing facials are the strongest levers here.',
              },
              {
                  id: 'pigmentation',
                  label: 'Pigmentation & sun damage',
                  hint: 'Dark spots, patchiness, uneven tone',
                  flavor: 'Where light has lingered too long.',
                  details: 'Excess melanin from UV exposure, hormones, or inflammation. Targeted serums plus brightening facials and gentle microneedling typically fade these gradually.',
              },
              {
                  id: 'dullness',
                  label: 'Dullness & dehydration',
                  hint: 'Tired, flat, no glow',
                  flavor: 'Skin that\u2019s lost its quiet light.',
                  details: 'A buildup of dead surface cells plus low water content in the skin. A high-tech facial with exfoliation, infusion, and LED is usually the fastest reset.',
              },
              {
                  id: 'acne',
                  label: 'Acne & breakouts',
                  hint: 'Breakouts and the marks they leave',
                  flavor: 'Quiet inflammation, made visible.',
                  details: 'Breakouts driven by oil, bacteria, or hormones. We treat both the active acne and any leftover marks with a sequenced facial protocol.',
              },
              {
                  id: 'volume',
                  label: 'Volume & firmness',
                  hint: 'Cheeks losing fullness, softer jawline',
                  flavor: 'What gravity gradually borrows.',
                  details: 'Bone, fat, and collagen all soften over time. Restoring volume and firmness usually means a combination of wrinkle relaxers, dermal filler, and collagen-stimulating treatments.',
              },
          ],
      },
      {
          id: 'age',
          eyebrow: 'Question 03',
          prompt: 'What is your skin age?',
          helper: 'This helps us balance prevention and repair.',
          options: [
              {
                  id: 'under30',
                  label: 'Under 30',
                  hint: 'Building a long-term routine',
                  flavor: 'Where prevention earns the most.',
              },
              {
                  id: '30to45',
                  label: '30 to 45',
                  hint: 'Maintaining and refining',
                  flavor: 'Where refinement begins in earnest.',
              },
              {
                  id: 'over45',
                  label: '45 +',
                  hint: 'Restoring and lifting',
                  flavor: 'Where restoration becomes the language.',
              },
          ],
      },
      {
          id: 'comfort',
          eyebrow: 'Question 04',
          prompt: 'What types of treatments interest you?',
          helper: 'You can always discuss this in-studio with your provider.',
          variant: 'photo',
          options: [
              {
                  id: 'topical',
                  label: 'Facials and light therapy',
                  hint: 'No needles, zero downtime',
                  flavor: 'On the surface, quietly effective.',
                  image: IMG.clarifyingHero,
                  details: 'No needles. Treatments stay on the surface of the skin: cleansing, microdermabrasion, oxygen infusion, and LED light therapy. Zero downtime.',
              },
              {
                  id: 'microneedling',
                  label: 'Open to microneedling',
                  hint: 'Minimal downtime, results build',
                  flavor: 'Beneath the surface, gently.',
                  image: DP4_DEVICE,
                  details: 'A pen creates microscopic channels in the skin to trigger collagen and let actives penetrate deeper. Mild redness for 24 hours, results compound over weeks.',
              },
              {
                  id: 'injectables',
                  label: 'Open to injectables',
                  hint: 'Botox, Dysport, or filler',
                  flavor: 'Reaching the structure underneath.',
                  image: IMG.botoxHero,
                  details: 'Wrinkle Relaxers (like Botox or Dysport) soften expression lines. Filler restores volume and contour. Both are placed conservatively for natural, undetectable results.',
              },
          ],
      },
      {
          id: 'skintype',
          eyebrow: 'Question 05',
          prompt: 'How would you best describe your skin type?',
          options: [
              {
                  id: 'oily',
                  label: 'Oily',
                  hint: 'Shiny by midday, bigger pores',
                  flavor: 'Skin that\u2019s quick to shine.',
                  details: 'You can tell by midday shine across the T-zone and cheeks, visible pores, and a tendency toward congestion. Oily skin usually responds well to clarifying facials and resurfacing.',
              },
              {
                  id: 'dry',
                  label: 'Dry',
                  hint: 'Tight, flaking, dull',
                  flavor: 'Skin that\u2019s slow to drink.',
                  details: 'You can tell by tightness after cleansing, occasional flaking, and a dull, papery feel. Hydration-led facials and barrier-supporting actives are the priority.',
              },
              {
                  id: 'combo',
                  label: 'Combination',
                  hint: 'Oily T-zone, drier cheeks',
                  flavor: 'Skin with two minds about itself.',
                  details: 'You can tell by shine on the forehead, nose, and chin, with normal-to-dry cheeks. The most common skin type, with treatments zoned and balanced.',
              },
              {
                  id: 'sensitive',
                  label: 'Sensitive',
                  hint: 'Reactive, easily flushed',
                  flavor: 'Skin that asks for patience first.',
                  details: 'You can tell by visible redness, a low tolerance for new products, and reactivity to heat or wind. Treatments stay gentle, calming, and barrier-first.',
              },
          ],
      },
      {
          id: 'cadence',
          eyebrow: 'Question 06',
          prompt: 'How would you describe your current skincare commitment?',
          helper: 'Members tend to see results compound faster.',
          options: [
              {
                  id: 'oneoff',
                  label: 'Once, to start',
                  hint: 'A single reset',
                  flavor: 'A single, considered reset.',
              },
              {
                  id: 'occasional',
                  label: 'Every few months',
                  hint: 'Seasonal touch-ups',
                  flavor: 'A seasonal return.',
              },
              {
                  id: 'monthly',
                  label: 'Monthly maintenance',
                  hint: 'Membership-friendly cadence',
                  flavor: 'A ritual.',
              },
          ],
      },
      {
          id: 'pace',
          eyebrow: 'Question 07',
          prompt: 'How quickly do you want to see results?',
          options: [
              {
                  id: 'subtle',
                  label: 'Subtle, over time',
                  hint: 'Builds quietly, looks natural',
                  flavor: 'Results that arrive quietly.',
              },
              {
                  id: 'event',
                  label: 'Visible, soon',
                  hint: 'In time for an event',
                  flavor: 'Results in time for the room.',
              },
          ],
      },
  ];
  // ── Treatment family map ────────────────────────────────────────────
  const TREATMENT_FAMILY = {
      signature: 'facial',
      express: 'facial',
      'sensitive-facial': 'facial',
      'clarifying-facial': 'facial',
      'hydrating-facial': 'facial',
      'brightening-facial': 'facial',
      'anti-aging-facial': 'facial',
      'regenerative-facial': 'facial',
      microneedling: 'microneedling',
      botox: 'injectables',
      filler: 'injectables',
      sculptra: 'injectables',
  };
  // ── Treatment base records (real Toula menu + pricing) ──────────────
  const TREATMENTS = {
      signature: {
          treatment: 'signature',
          name: 'The Signature Facial',
          tagline: 'A skin assessment and a high-tech facial, mapped to a long-term plan.',
          duration: '70 min · 20-min assessment + 50-min facial',
          priceLine: 'Drop-in $199 · Member $179',
          priceItems: [{ label: 'Drop-in', value: '$199' }, { label: 'Member', value: '$179' }],
          priceSource: 'Current service-page price',
          bookingUrl: BOOK_LINKS.signature,
          heroImage: IMG.hydratingHero,
      },
      express: {
          treatment: 'express',
          name: 'The Express',
          tagline: 'A 30-minute reset, before the room.',
          duration: '30 min',
          priceLine: 'Drop-in $99 · Member $89',
          priceItems: [{ label: 'Drop-in', value: '$99' }, { label: 'Member', value: '$89' }],
          priceSource: 'Current service-page price',
          bookingUrl: BOOK_LINKS.express,
          heroImage: IMG.expressHero,
      },
      'sensitive-facial': {
          treatment: 'sensitive-facial',
          name: 'Sensitive Skin Facial',
          tagline: 'Calming, barrier-first, completely undramatic.',
          duration: '50 min',
          priceLine: 'Drop-in $165 · Member $149',
          priceItems: [{ label: 'Drop-in', value: '$165' }, { label: 'Member', value: '$149' }],
          priceSource: 'Current service-page price',
          bookingUrl: BOOK_LINKS['sensitive-facial'],
          heroImage: IMG.sensitiveHero,
      },
      'clarifying-facial': {
          treatment: 'clarifying-facial',
          name: 'Clarifying Facial',
          tagline: 'A deep clean for skin that needs to come up for air.',
          duration: '50 min',
          priceLine: 'Drop-in $209 · Member $179',
          priceItems: [{ label: 'Drop-in', value: '$209' }, { label: 'Member', value: '$179' }],
          priceSource: 'Current service-page price',
          bookingUrl: BOOK_LINKS['clarifying-facial'],
          heroImage: IMG.clarifyingHero,
      },
      'hydrating-facial': {
          treatment: 'hydrating-facial',
          name: 'Hydrating Facial',
          tagline: 'Microcurrent and infusion, a slow pour of water back into the skin.',
          duration: '50 min',
          priceLine: 'Drop-in $225 · Member $189',
          priceItems: [{ label: 'Drop-in', value: '$225' }, { label: 'Member', value: '$189' }],
          priceSource: 'Current service-page price',
          bookingUrl: BOOK_LINKS['hydrating-facial'],
          heroImage: IMG.hydratingHero,
      },
      'brightening-facial': {
          treatment: 'brightening-facial',
          name: 'Brightening Facial',
          tagline: 'Microdermabrasion, microcurrent, and light, in concert.',
          duration: '50 min',
          priceLine: 'Drop-in $235 · Member $199',
          priceItems: [{ label: 'Drop-in', value: '$235' }, { label: 'Member', value: '$199' }],
          priceSource: 'Current service-page price',
          bookingUrl: BOOK_LINKS['brightening-facial'],
          heroImage: IMG.brighteningHero,
      },
      'anti-aging-facial': {
          treatment: 'anti-aging-facial',
          name: 'Anti-Aging Facial',
          tagline: 'The most intensive of the 50-minute facials. Lift, tone, slow visible change.',
          duration: '50 min',
          priceLine: 'Drop-in $250 · Member $215',
          priceItems: [{ label: 'Drop-in', value: '$250' }, { label: 'Member', value: '$215' }],
          priceSource: 'Current service-page price',
          bookingUrl: BOOK_LINKS['anti-aging-facial'],
          heroImage: IMG.antiAgingHero,
      },
      'regenerative-facial': {
          treatment: 'regenerative-facial',
          name: 'Regenerative Facial',
          tagline: 'Every device we own, in one 50-minute protocol, to rebuild from the surface down.',
          duration: '50 min',
          priceLine: 'Drop-in $265 · Member $225',
          priceItems: [{ label: 'Drop-in', value: '$265' }, { label: 'Member', value: '$225' }],
          priceSource: 'Current service-page price',
          bookingUrl: BOOK_LINKS['regenerative-facial'],
          heroImage: IMG.regenerativeHero,
      },
      microneedling: {
          treatment: 'microneedling',
          name: 'Advanced Microneedling',
          tagline: 'Dermapen 4 for collagen induction and refined texture.',
          duration: '60 min · with numbing and recovery serum',
          priceLine: 'Drop-in $349 · Member $299 · 3-session $699',
          priceItems: [{ label: 'Drop-in', value: '$349' }, { label: 'Member', value: '$299' }, { label: '3-session', value: '$699' }],
          priceSource: 'Current service-page price',
          bookingUrl: BOOK_LINKS.microneedling,
          heroImage: IMG.microneedlingHero,
      },
      botox: {
          treatment: 'botox',
          name: 'Neuromodulators',
          tagline: 'Botox or Dysport, placed with restraint.',
          duration: '30 min',
          priceLine: 'Botox $13/$12 member per unit · Dysport $11/$10 member per unit',
          priceItems: [{ label: 'Botox', value: '$13 / $12' }, { label: 'Dysport', value: '$11 / $10' }],
          priceLegend: 'Drop-in / member · per unit',
          priceSource: 'Current service-page price',
          bookingUrl: BOOK_LINKS.botox,
          heroImage: IMG.botoxHero,
      },
      filler: {
          treatment: 'filler',
          name: 'Dermal Filler',
          tagline: 'Cheeks, lips, and jawline, restored without overcorrection.',
          duration: '60 min',
          priceLine: 'Half syringe $375/$350 member · Full $675/$650 member',
          priceItems: [{ label: 'Half syringe', value: '$375 / $350' }, { label: 'Full syringe', value: '$675 / $650' }],
          priceLegend: 'Drop-in / member pricing',
          priceSource: 'Current service-page price',
          bookingUrl: BOOK_LINKS.filler,
          heroImage: IMG.fillerHero,
      },
      sculptra: {
          treatment: 'sculptra',
          name: 'Sculptra',
          tagline: 'A collagen biostimulator. Quiet, gradual, lasting.',
          duration: '60 min · series of 2–3 over 4–8 weeks',
          priceLine: 'Per vial $850 · Member $800',
          priceItems: [{ label: 'Per vial', value: '$850' }, { label: 'Member', value: '$800' }],
          priceSource: 'Current service-page price',
          bookingUrl: BOOK_LINKS.sculptra,
          heroImage: IMG.sculptraHero,
      },
  };
  // ── What's Included (per treatment) ─────────────────────────────────
  // Every concrete claim below is verifiable on the matching toulastudio.com
  // /pages/<treatment> page. Where Toula is vague, we stay vague rather than
  // invent specifics (consultation duration, take-home samples, follow-up
  // schedules, etc. were stripped where they couldn't be verified).
  const INCLUDED = {
      signature: [
          { step: '01', title: 'Skin Assessment', body: 'A complimentary 20-minute skin assessment: a diagnostic reading of your skin condition, hydration, and underlying concerns.' },
          { step: '02', title: 'High-Tech Facial', body: 'A personalized 50-minute high-tech facial, recommended by your esthetician and tailored to what the assessment reveals.' },
          { step: '03', title: 'Your Long-Term Plan', body: 'You leave with a precise understanding of your skin and a long-term plan for where to go next.' },
      ],
      express: [
          { step: '01', title: 'Consultation', body: 'A brief consultation with your skincare specialist to discuss your skin type and goals before treatment begins.' },
          { step: '02', title: 'The Treatment', body: 'Diamond microdermabrasion, lymphatic drainage, oxygen infusion, and LED light therapy, designed to land in 30 minutes without rushing.' },
          { step: '03', title: 'After', body: 'Tailored product recommendations and at-home tips to maintain your post-facial glow. No downtime.' },
      ],
      'sensitive-facial': [
          { step: '01', title: 'Consultation', body: 'A consultation with your skincare specialist to discuss skin concerns, sensitivities, and goals, and your treatment is tailored from there.' },
          { step: '02', title: 'The Treatment', body: 'Lymphatic drainage, oxygen spray, BioSonix ultrasound, and an LED panel with oxygen infusion, calibrated to your reactivity.' },
          { step: '03', title: 'Aftercare', body: 'Personalized aftercare instructions and product guidance to keep skin calm. No downtime.' },
      ],
      'clarifying-facial': [
          { step: '01', title: 'Consultation', body: 'A personalized consultation with your skincare expert to discuss specific concerns before treatment begins.' },
          { step: '02', title: 'The Treatment', body: 'Deep cleansing, gentle exfoliation and extractions, lymphatic drainage, BioSonix ultrasound, oxygen spray, and a multi-colour LED light panel with oxygen infusion.' },
          { step: '03', title: 'Aftercare', body: 'Aftercare and recovery recommendations from your specialist. No downtime.' },
      ],
      'hydrating-facial': [
          { step: '01', title: 'Consultation', body: 'A personalized consultation with your skincare expert to discuss your specific hydration and barrier needs.' },
          { step: '02', title: 'The Treatment', body: 'Lymphatic drainage, oxygen spray, MyoLight microcurrent with red-light therapy, BioSonix ultrasound, and an LED panel with oxygen mist, built to strengthen the skin\u2019s natural barrier.' },
          { step: '03', title: 'Aftercare', body: 'Aftercare advice focused on continued hydration and gentle cleansing. No downtime.' },
      ],
      'brightening-facial': [
          { step: '01', title: 'Consultation', body: 'A personalized consultation with your skincare expert to map tone, sun history, and where pigmentation sits.' },
          { step: '02', title: 'The Treatment', body: 'Diamond microdermabrasion, lymphatic drainage, MyoLight microcurrent, BioSonix ultrasound, oxygen spray, and a multi-colour LED light panel with oxygen infusion.' },
          { step: '03', title: 'Aftercare', body: 'Aftercare and product recommendations from your specialist. Mild redness that fades quickly.' },
      ],
      'anti-aging-facial': [
          { step: '01', title: 'Consultation', body: 'A personalized consultation with your skincare expert to discuss your specific aging concerns, skin type, and goals.' },
          { step: '02', title: 'The Treatment', body: 'Lymphatic drainage, oxygen spray, MyoLight microcurrent with red-light therapy, BioSonix ultrasound, and an LED panel with oxygen mist, built to boost collagen and improve elasticity.' },
          { step: '03', title: 'Aftercare', body: 'Hydrating, gentle aftercare recommendations and sun-exposure guidance. No downtime.' },
      ],
      'regenerative-facial': [
          { step: '01', title: 'Consultation', body: 'A personalized consultation with your skincare expert to read your skin, map your goals, and calibrate the protocol before treatment begins.' },
          { step: '02', title: 'The Treatment', body: 'Diamond microdermabrasion, MyoLight microcurrent with red-light and LED therapy, BioSonix ultrasound, oxygen serum infusion, and lymphatic drainage, layered into one regenerative session that resurfaces, tones, and rebuilds.' },
          { step: '03', title: 'Aftercare', body: 'Tailored aftercare and product guidance to extend the glow. No downtime.' },
      ],
      microneedling: [
          { step: '01', title: 'Consultation & Prep', body: 'A consultation to map your concerns. Avoid active skincare for 3\u20135 days before the treatment.' },
          { step: '02', title: 'Dp4 Treatment', body: 'The Dp4 by DermapenWorld using Advanced Vertical Needle technology that reaches up to 1,920 micro-channels per second to trigger collagen, finished with a Meso Glide serum matched to your skin so actives go deeper than topical can reach.' },
          { step: '03', title: 'Recovery', body: 'Hyaluronic acid serum, mineral SPF 30+, and a gentle cleanser. Mild redness for 24\u201348 hours, full healing within 5\u20137 days. Avoid makeup, exercise, saunas, and swimming for 24 hours.' },
      ],
      botox: [
          { step: '01', title: 'Consultation', body: 'A complimentary consultation for new clients. Your provider assesses your skin, health history, and goals before any placement.' },
          { step: '02', title: 'Placement', body: 'Conservative dosing across forehead, frown lines, brow lift, bunny lines, lip flip, chin, masseter, or jawline, treating only what is needed.' },
          { step: '03', title: 'After', body: 'Mild redness, pinpoint bumps, or slight swelling resolves in 30 minutes to a few hours. Dysport begins showing in 2\u20133 days, Botox in 3\u20135. Full effect at 10\u201314 days. Results last 3\u20134 months.' },
      ],
      filler: [
          { step: '01', title: 'Consultation', body: 'A 1:1 consultation to assess your goals, facial anatomy, skin health, and medical history. Your provider builds a customized plan that prioritizes balance, safety, and subtlety.' },
          { step: '02', title: 'Placement', body: 'HA filler placed across cheeks, lips, jawline, chin, temples, tear trough, or nasolabial folds, conservatively, only where it is needed.' },
          { step: '03', title: 'Settle', body: 'Cold compress applied post-treatment. Mild swelling for a day or two. Results settle in 5\u201310 days and last 6\u201318 months depending on the product and area.' },
      ],
      sculptra: [
          { step: '01', title: 'Consultation', body: 'A consultation with your medical injector to assess your needs and build a personalized plan. Sculptra is a series, not a single visit.' },
          { step: '02', title: 'The Series', body: '2\u20133 initial sessions spaced 4\u20138 weeks apart, then yearly maintenance. Each session is a careful injection of the biostimulator.' },
          { step: '03', title: 'At Home & After', body: 'Massage the treated area for 5 minutes, 5 times a day, for 5 days, using moisturizer or Arnica cream. Mild swelling for a day or two. Results emerge gradually over weeks and last approximately 2\u20134 years with maintenance.' },
      ],
  };
  // ── Testimonials (per family) ───────────────────────────────────────
  // Real, verbatim-faithful excerpts from TOULA's public Google reviews (4.9★, 109 reviews).
  const TESTIMONIALS = {
      facial: {
          quote: 'The first facial I’ve ever had where the results were immediate and super noticeable — days later, my skin is still smooth and even-toned.',
          attribution: 'Aly MacMillan',
      },
      microneedling: {
          quote: 'I went to TOULA for a microneedling package, and the results have been noticeable after two sessions. The people are awesome — that’s why I’ll be coming back.',
          attribution: 'Daniel Berant',
      },
      injectables: {
          quote: 'Facials, microneedling, dermal filler, botox — top-tier medspa in products and technology, with excellent ambience. The staff are well educated; I definitely know I’m in good hands. A true gem and must-visit in Toronto.',
          attribution: 'Sydney Huk',
      },
  };
  // ── Membership TIER match (per recommended treatment) ───────────────
  // Maps the recommended treatment to the real Toula membership tier that
  // includes (or best serves) it. Prices/structure verified from
  // toulastudio.com/pages/our-memberships. Facial tiers alternate two
  // facials each month; anything without a fixed monthly-facial home falls
  // back to Beauty Bank ($149 banked toward any treatment/product).
  // skincarePct: Elevate members get 15% off skincare, all others 10%.
  const MEMBERSHIP_TIERS = {
      express:              { kind: 'facial', tier: 'Essence', price: 89,  facial: 'The Express',           alternate: null },
      'sensitive-facial':   { kind: 'facial', tier: 'Empower', price: 169, facial: 'Sensitive Skin Facial', alternate: 'Clarifying Facial' },
      'clarifying-facial':  { kind: 'facial', tier: 'Empower', price: 169, facial: 'Clarifying Facial',     alternate: 'Sensitive Skin Facial' },
      'hydrating-facial':   { kind: 'facial', tier: 'Enhance', price: 189, facial: 'Hydrating Facial',      alternate: 'Brightening Facial' },
      'brightening-facial': { kind: 'facial', tier: 'Enhance', price: 189, facial: 'Brightening Facial',    alternate: 'Hydrating Facial' },
      'anti-aging-facial':  { kind: 'facial', tier: 'Elevate', price: 219, facial: 'Anti-Aging Facial',     alternate: 'Regenerative Facial', skincarePct: 15 },
      'regenerative-facial':{ kind: 'facial', tier: 'Elevate', price: 219, facial: 'Regenerative Facial',   alternate: 'Anti-Aging Facial',   skincarePct: 15 },
  };
  const BEAUTY_BANK_TIER = { kind: 'beauty-bank', tier: 'Beauty Bank', price: 149 };
  // ── Pairs Well With (per treatment) ─────────────────────────────────
  const PAIRS_WITH = {
      express: {
          name: 'Add a Hydrating Facial',
          blurb: 'Layer in a 50-minute Hydrating Facial monthly to keep what The Express began.',
          image: IMG.hydratingHero,
          bookingUrl: BOOK_LINKS['hydrating-facial'],
      },
      'sensitive-facial': {
          name: 'Add LED Light Therapy',
          blurb: 'A 30-minute LED add-on calms reactive skin further between visits, included free with all memberships.',
          image: IMG.led,
          bookingUrl: BOOK_LINKS.led,
      },
      'clarifying-facial': {
          name: 'Add Microneedling later',
          blurb: 'When the active acne is settled, microneedling is the strongest tool for any post-acne marks left behind.',
          image: IMG.microneedlingHero,
          bookingUrl: BOOK_LINKS.microneedling,
      },
      'hydrating-facial': {
          name: 'Add an LED Boost',
          blurb: 'A 30-minute LED add-on extends the hydration and adds a calm, post-treatment glow.',
          image: IMG.led,
          bookingUrl: BOOK_LINKS.led,
      },
      'brightening-facial': {
          name: 'Add Microneedling',
          blurb: 'For deeper or more stubborn pigmentation, microneedling extends what the facial begins.',
          image: IMG.microneedlingHero,
          bookingUrl: BOOK_LINKS.microneedling,
      },
      'anti-aging-facial': {
          name: 'Add Microneedling',
          blurb: 'When you are ready to take collagen induction further, microneedling pairs cleanly with this protocol.',
          image: IMG.microneedlingHero,
          bookingUrl: BOOK_LINKS.microneedling,
      },
      'regenerative-facial': {
          name: 'Add Microneedling',
          blurb: 'To push collagen induction past what devices alone reach, microneedling is the natural next layer on this protocol.',
          image: IMG.microneedlingHero,
          bookingUrl: BOOK_LINKS.microneedling,
      },
      microneedling: {
          name: 'Add a Brightening Facial',
          blurb: 'A monthly Brightening Facial supports the recovery between microneedling sessions.',
          image: IMG.brighteningHero,
          bookingUrl: BOOK_LINKS['brightening-facial'],
      },
      botox: {
          name: 'Consider Filler',
          blurb: 'When volume becomes the conversation, dermal filler complements wrinkle relaxers in the same visit.',
          image: IMG.fillerHero,
          bookingUrl: BOOK_LINKS.filler,
      },
      filler: {
          name: 'Add Botox or Dysport',
          blurb: 'Lines and volume are different problems. Filler restores, wrinkle relaxers soften, and they are typically used together.',
          image: IMG.botoxHero,
          bookingUrl: BOOK_LINKS.botox,
      },
      sculptra: {
          name: 'Add a Hydrating Facial',
          blurb: 'While Sculptra rebuilds collagen underneath, a monthly Hydrating Facial keeps the surface smooth, calm, and glowing between sessions.',
          image: IMG.hydratingHero,
          bookingUrl: BOOK_LINKS['hydrating-facial'],
      },
  };
  // ── Routing ─────────────────────────────────────────────────────────
  const CONCERN_LABEL = {
      lines: 'fine lines and early wrinkles',
      texture: 'skin texture and pore visibility',
      pigmentation: 'pigmentation and sun damage',
      dullness: 'dullness and dehydration',
      acne: 'breakouts and post-acne marks',
      volume: 'volume loss and firmness',
  };
  const IDEAL_TREATMENT = {
      lines: 'botox',
      volume: 'filler',
      texture: 'microneedling',
      pigmentation: 'microneedling',
      dullness: 'hydrating-facial',
      acne: 'clarifying-facial',
  };
  const NEXT_STEP_DESC = {
      facial: 'a high-tech facial',
      microneedling: 'microneedling',
      injectables: 'wrinkle relaxers or filler',
  };
  const COMFORT_PREFERENCE = {
      topical: 'non-invasive',
      microneedling: 'less-invasive',
  };
  const DEEPER_WORK_PHRASE = {
      lines: 'fuller wrinkle softening',
      volume: 'real volume restoration',
      texture: 'deeper texture and pore work',
      pigmentation: 'more targeted pigmentation correction',
  };
  // Light/surface concerns that the Express can genuinely address. Lines,
  // volume, and pigmentation are deliberately excluded — they need real
  // treatments, so Express must never cannibalize them.
  const EXPRESS_CONCERNS = new Set(['dullness', 'acne', 'texture']);
  // Pick the right facial when comfort = topical or as a fallback.
  function pickFacial(concern, skintype, age, pace, cadence) {
      if (skintype === 'sensitive')
          return 'sensitive-facial';
      // Express — the entry / "just once" pick AND a widened event-glow option.
      // Reachable for light/surface concerns on non-sensitive skin when the user
      // is coming in once to start, OR when they need a glow before an event.
      // Never for lines / volume / pigmentation (handled below first anyway).
      if (EXPRESS_CONCERNS.has(concern) &&
          (cadence === 'oneoff' || pace === 'event')) {
          return 'express';
      }
      if (concern === 'acne') {
          return skintype === 'dry' ? 'hydrating-facial' : 'clarifying-facial';
      }
      if (concern === 'pigmentation')
          return 'brightening-facial';
      if (concern === 'lines' || concern === 'volume') {
          return age === 'over45' ? 'regenerative-facial' : 'anti-aging-facial';
      }
      if (skintype === 'dry')
          return 'hydrating-facial';
      return 'hydrating-facial';
  }
  const ANSWER_VALUES = {
      firsttime: new Set(['yes', 'returning']),
      concern: new Set(['lines', 'texture', 'pigmentation', 'dullness', 'acne', 'volume']),
      age: new Set(['under30', '30to45', 'over45']),
      comfort: new Set(['topical', 'microneedling', 'injectables']),
      skintype: new Set(['oily', 'dry', 'combo', 'sensitive']),
      cadence: new Set(['oneoff', 'occasional', 'monthly']),
      pace: new Set(['subtle', 'event']),
  };
  const ANSWER_KEYS = Object.keys(ANSWER_VALUES);

  function hasCompleteAnswers(answers) {
      return !!answers && ANSWER_KEYS.every((key) => ANSWER_VALUES[key].has(answers[key]));
  }

  function recommend(answers) {
      const valid = hasCompleteAnswers(answers);
      const safeAnswers = valid ? answers : {
          firsttime: 'returning',
          concern: 'dullness',
          age: '30to45',
          comfort: 'topical',
          skintype: 'combo',
          cadence: 'occasional',
          pace: 'subtle',
      };
      const { concern, comfort, cadence, age, skintype, pace } = safeAnswers;
      const ideal = IDEAL_TREATMENT[concern] || 'hydrating-facial';
      const idealFamily = TREATMENT_FAMILY[ideal];
      let treatment = ideal;
      let downgradeReason = valid ? null : 'consult';

      // Sensitive skin always wins over resurfacing and microneedling. Injectable
      // decisions remain provider-led, so a sensitive injectable path is consult-only.
      if (skintype === 'sensitive' && idealFamily !== 'injectables') {
          treatment = 'sensitive-facial';
          if (idealFamily !== 'facial') downgradeReason = 'sensitive';
      } else if (skintype === 'sensitive' && idealFamily === 'injectables' && comfort !== 'injectables') {
          treatment = 'sensitive-facial';
          downgradeReason = 'sensitive';
      } else if (idealFamily === 'injectables' && comfort !== 'injectables') {
          treatment = comfort === 'microneedling' ? 'microneedling' : pickFacial(concern, skintype, age, pace, cadence);
          downgradeReason = 'comfort';
      } else if (idealFamily === 'microneedling' && comfort === 'topical') {
          treatment = pickFacial(concern, skintype, age, pace, cadence);
          downgradeReason = 'comfort';
      } else if (idealFamily === 'facial') {
          treatment = pickFacial(concern, skintype, age, pace, cadence);
      } else if (treatment === 'microneedling' && pace === 'event') {
          treatment = 'brightening-facial';
          downgradeReason = 'pace';
      }

      if (treatment === 'microneedling' && skintype === 'sensitive') {
          treatment = 'sensitive-facial';
          downgradeReason = 'sensitive';
      }
      if (treatment === 'filler' && pace === 'subtle' && cadence !== 'oneoff') {
          treatment = 'sculptra';
      }

      // First-time visitors on a facial outcome start with the Signature Facial
      // (assessment + facial + long-term plan). Microneedling and injectable
      // outcomes are honored as-is.
      if (safeAnswers.firsttime === 'yes' && TREATMENT_FAMILY[treatment] === 'facial') {
          treatment = 'signature';
      }

      const family = TREATMENT_FAMILY[treatment] || 'facial';
      const base = TREATMENTS[treatment] || TREATMENTS['hydrating-facial'];
      const concernLabel = CONCERN_LABEL[concern] || 'your skin goals';
      let firstBullet;
      if (treatment === 'signature') {
          firstBullet = 'As your first visit, we start with a full skin assessment and a personalized facial, then map your long-term plan.';
      } else if (downgradeReason === 'consult') {
          firstBullet = 'We have kept this recommendation conservative so your provider can confirm the right next step.';
      } else if (downgradeReason === 'pace') {
          firstBullet = 'You want results before a milestone, so we start with a faster-glow facial.';
      } else if (downgradeReason === 'comfort') {
          firstBullet = `Matched to how far you want to go right now, with ${NEXT_STEP_DESC[idealFamily] || 'more advanced options'} open whenever you are ready.`;
      } else if (downgradeReason === 'sensitive') {
          firstBullet = `Your sensitive skin sets the pace. We treat the ${concernLabel} gently and build from there.`;
      } else if (skintype === 'sensitive' && treatment === 'sensitive-facial' && concern === 'acne') {
          firstBullet = 'Your sensitive skin takes priority, so we calm first and build toward congestion work as your barrier stabilizes.';
      } else if (skintype === 'sensitive' && treatment === 'sensitive-facial') {
          firstBullet = `Calibrated around your sensitive skin, treating the ${concernLabel} without provoking it.`;
      } else {
          firstBullet = `Built around your focus on ${concernLabel}.`;
      }
      const thirdBullet = pace === 'event' && downgradeReason !== 'pace'
          ? 'Sequenced for visible results before your next milestone.'
          : skintype === 'sensitive'
              ? 'Kept gentle, with results that build steadily over time.'
              : `Built for ${skintype === 'combo' ? 'combination' : skintype} skin, with results that build gradually.`;
      const reasonBullets = [
          firstBullet,
          age === 'under30' ? 'Tuned for prevention and long-term skin health.' : age === 'over45' ? 'Tuned for restoration and lift.' : 'Tuned for maintenance and quiet refinement.',
          thirdBullet,
      ];
      const membership = MEMBERSHIP_TIERS[treatment] || BEAUTY_BANK_TIER;
      const requiresConsult = !valid || downgradeReason === 'sensitive';
      return {
          ...base,
          family,
          reasonBullets,
          included: INCLUDED[treatment] || INCLUDED['hydrating-facial'],
          testimonial: TESTIMONIALS[family] || TESTIMONIALS.facial,
          membership,
          requiresConsult,
          consultReason: requiresConsult ? 'A TOULA provider should confirm this recommendation before treatment.' : '',
          bookingUrl: requiresConsult ? BOOK_LINKS.skinAnalysis : base.bookingUrl,
          showMicroneedlingAddon: comfort === 'microneedling' && treatment !== 'microneedling' && skintype !== 'sensitive',
          showInjectablesCallout: safeAnswers.comfort === 'injectables'
              && TREATMENT_FAMILY[treatment] !== 'injectables'
              && !requiresConsult,
          pairsWith: PAIRS_WITH[treatment],
      };
  }
  

  function escapeHtml(value) {
    return String(value ?? "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function styleBg(url) {
    return url ? ' style="background-image: url(' + escapeHtml(url) + ')"' : '';
  }

  function checkMark() {
    return '<svg viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M2 7.5L5.5 11L12 3" stroke="#c1a355" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  function photoCheckMark() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7" /></svg>';
  }

  // Single consistent line-arrow for all buttons (dir: 'right' | 'left').
  function arrowIcon(dir) {
    const cls = dir === 'left' ? 'btnArrow btnArrow--left' : 'btnArrow';
    return '<svg class="' + cls + '" viewBox="0 0 26 12" fill="none" aria-hidden="true"><path d="M1 6h22m-6-5 6 5-6 5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  function initQuiz(section) {
    const shell = section.querySelector(".toula-quiz-shell");
    if (!shell) return;

    const state = {
      phase: "welcome",
      step: 0,
      answers: {},
      openDetailsId: null,
      advancing: false,
      completionEmitted: false,
      membershipUrl: section.dataset.membershipUrl || DEFAULT_MEMBERSHIP_URL,
      // Welcome hero URL comes from the section (theme editor); the Liquid
      // preloads the same URL so the browser fetches it once.
      heroSrc: section.dataset.heroSrc || WELCOME_AMBIENT
    };

    function render() {
      // Shopify's standard page template already supplies the document-level
      // <main>. Keep the quiz stage a div so the preview never nests main
      // landmarks inside that layout.
      shell.innerHTML = '<div class="shell" data-phase="' + escapeHtml(state.phase) + '">' + renderQuizChrome() + '<div class="stage">' + renderStage() + '</div></div>';
      bind();
    }

    function renderQuizChrome() {
      if (state.phase === "welcome") return "";
      return renderProgress();
    }

    function renderProgress() {
      const totalQuestions = QUESTIONS.length;
      const readout = state.phase === "result"
        ? '<span class="progressResultLabel">Your Match · Complete</span>'
        : '<span class="progressCount"><span class="progressCur">' + String(state.step + 1).padStart(2, '0') + '</span><span class="progressSep">/</span><span class="progressTot">' + String(totalQuestions).padStart(2, '0') + '</span></span>';
      return '<div class="progressWrap"><div class="progressReadout">' +
        (state.phase === "question" ? '<button type="button" class="backButton" data-action="back">' + arrowIcon('left') + ' Back</button>' : '') +
        readout +
        '<button type="button" class="iconButton progressRestart" data-action="restart">Restart</button>' +
      '</div><div class="rail" aria-hidden="true">' + QUESTIONS.map((q, i) => {
        const done = state.phase === "result" || i < state.step;
        const active = state.phase === "question" && i === state.step;
        return '<span class="railSeg' + (done ? ' railSegDone' : '') + (active ? ' railSegActive' : '') + '"></span>';
      }).join('') + '</div></div>';
    }

    function renderStage() {
      if (state.phase === "welcome") return renderWelcome();
      if (state.phase === "result") return renderResult();
      return renderQuestion();
    }

    function renderWelcome() {
      return '<section class="welcome animate" key="welcome">' +
        '<div class="welcomeFrame"><div class="welcomeFramePhoto"' + styleBg(state.heroSrc) + ' aria-hidden="true"></div><span class="welcomeFrameCaption">The Studio · King West</span></div>' +
        '<div class="welcomeContent">' +
          '<div class="welcomeHero"><h1 class="welcomeTitle">The Perfect<br>Skincare Plan<br>for <em>You</em></h1><p class="welcomeBody">Answer the kind of questions our expert in-studio team asks during a consult, and know exactly which treatments and membership tiers fit with your skincare goals.</p></div>' +
          '<div class="welcomeMeta"><div class="metaItem"><span class="metaNum">7</span><span class="metaLab">Questions</span></div><div class="metaItem"><span class="metaNum">90</span><span class="metaLab">Seconds</span></div><div class="metaItem"><span class="metaNum">1</span><span class="metaLab">Match</span></div></div>' +
          '<div class="welcomeCtaWrap"><button type="button" class="toula-button toula-button-large" data-action="start">Find My Treatment ' + arrowIcon('right') + '</button></div>' +
          '<div class="welcomeIncentive"><span class="incentiveFlo" aria-hidden="true"></span><span>Your <b>treatment plan</b>, no pressure to book.</span><span class="incentiveFlo incentiveFloR" aria-hidden="true"></span></div>' +
        '</div>' +
      '</section>';
    }

    function renderQuestion() {
      const question = QUESTIONS[state.step];
      const isPhoto = question.variant === "photo";
      return '<section class="question animate" key="q-' + escapeHtml(question.id) + '-' + state.step + '">' +
        '<div class="questionHeader"><span class="questionEyebrow">' + escapeHtml(question.eyebrow) + '</span><h2 class="questionPrompt">' + escapeHtml(question.prompt) + '</h2>' + (question.helper ? '<p class="questionHelper">' + escapeHtml(question.helper) + '</p>' : '') + '</div>' +
        '<div class="' + (isPhoto ? 'cardsPhoto' : 'cardsTypographic') + '" role="radiogroup" aria-label="' + escapeHtml(question.prompt) + '">' +
          question.options.map((opt, i) => isPhoto ? renderPhotoCard(question, opt, i) : renderTypographicCard(question, opt, i)).join('') +
        '</div>' +
        '<p class="questionFootnote">Your answers shape one tailored recommendation<span class="footDot" aria-hidden="true"></span>nothing is shared</p>' +
      '</section>';
    }

    function renderTypographicCard(question, opt, index) {
      const selected = state.answers[question.id] === opt.id;
      const detailsOpen = state.openDetailsId === opt.id;
      const numeral = String(index + 1).padStart(2, '0');
      const detailId = 'toula-detail-' + escapeHtml(opt.id);
      return '<div class="answerCardWrap answerCardWrapTypographic' + (detailsOpen ? ' detailIsOpen' : '') + '" style="--card-delay:' + (index * 60) + 'ms">' +
        '<button type="button" role="radio" aria-checked="' + (selected ? 'true' : 'false') + '" class="cardTypographic' + (selected ? ' cardSelected' : '') + '" data-action="answer" data-answer="' + escapeHtml(opt.id) + '"' + (opt.details ? ' aria-controls="' + detailId + '"' : '') + '>' +
          '<span class="cardNumeral">' + numeral + '</span>' +
          '<span class="cardMain"><span class="cardLabel">' + escapeHtml(opt.label) + '</span>' + (opt.hint ? '<span class="cardHint">' + escapeHtml(opt.hint) + '</span>' : '') + (opt.flavor ? '<span class="cardFlavor">' + escapeHtml(opt.flavor) + '</span>' : '') + '</span>' +
          '<span class="cardSide"><span class="cardCheck">' + checkMark() + '</span></span>' +
        '</button>' +
        (opt.details ? '<button type="button" aria-label="More about ' + escapeHtml(opt.label) + '" aria-expanded="' + (detailsOpen ? 'true' : 'false') + '" class="detailToggle" data-action="detail" data-answer="' + escapeHtml(opt.id) + '" aria-controls="' + detailId + '">i</button>' : '') +
        (detailsOpen && opt.details ? renderDetailOverlay(opt, detailId) : '') +
      '</div>';
    }

    function renderPhotoCard(question, opt, index) {
      const selected = state.answers[question.id] === opt.id;
      const detailsOpen = state.openDetailsId === opt.id;
      const detailId = 'toula-detail-' + escapeHtml(opt.id);
      return '<div class="answerCardWrap answerCardWrapPhoto' + (detailsOpen ? ' detailIsOpen' : '') + '" style="--card-delay:' + (index * 60) + 'ms">' +
        '<button type="button" role="radio" aria-checked="' + (selected ? 'true' : 'false') + '" class="cardPhoto' + (selected ? ' cardSelected' : '') + '" data-action="answer" data-answer="' + escapeHtml(opt.id) + '"' + (opt.details ? ' aria-controls="' + detailId + '"' : '') + '>' +
          '<div class="cardMedia"' + styleBg(opt.image) + ' aria-hidden="true"><span class="cardChip">' + escapeHtml(opt.label) + '</span><span class="cardMark" aria-hidden="true">' + photoCheckMark() + '</span></div>' +
          '<div class="cardCaption"><span class="cardLabel">' + escapeHtml(opt.label) + '<span class="cardPhotoSelectedTag" aria-hidden="true">Selected</span></span>' + (opt.hint ? '<span class="cardHint">' + escapeHtml(opt.hint) + '</span>' : '') + (opt.flavor ? '<span class="cardFlavor">' + escapeHtml(opt.flavor) + '</span>' : '') + '</div>' +
        '</button>' +
        (opt.details ? '<button type="button" aria-label="More about ' + escapeHtml(opt.label) + '" aria-expanded="' + (detailsOpen ? 'true' : 'false') + '" class="detailToggle" data-action="detail" data-answer="' + escapeHtml(opt.id) + '" aria-controls="' + detailId + '">i</button>' : '') +
        (detailsOpen && opt.details ? renderDetailOverlay(opt, detailId) : '') +
      '</div>';
    }

    function renderDetailOverlay(opt, detailId) {
      const labelId = detailId + '-label';
      return '<div id="' + detailId + '" class="detailOverlay" role="dialog" aria-modal="true" aria-labelledby="' + labelId + '" data-detail-overlay><div class="detailOverlayHeader"><p id="' + labelId + '" class="detailOverlayLabel">' + escapeHtml(opt.label) + '</p><button type="button" class="detailOverlayClose" aria-label="Close detail" data-action="close-detail">×</button></div><p class="detailOverlayBody">' + escapeHtml(opt.details) + '</p></div>';
    }

    function renderResult() {
      const rec = recommend(state.answers);
      // Keep duration and investment metadata structured so mobile can lay out
      // price rows without turning long injectable copy into an unreadable stack.
      const metaStack = (v, kind) => {
        if (kind !== 'price' || !rec.priceItems) {
          return String(v).split(' · ').map((s) => '<span class="metaLine">' + escapeHtml(s) + '</span>').join('');
        }
        return '<div class="priceList">' + rec.priceItems.map((item) => '<span class="priceItem"><span class="priceItemLabel">' + escapeHtml(item.label) + '</span><span class="priceItemValue">' + escapeHtml(item.value) + '</span></span>').join('') + '</div>' + (rec.priceLegend ? '<span class="priceLegend">' + escapeHtml(rec.priceLegend) + '</span>' : '');
      };
      const pairBookLabel = rec.pairsWith ? rec.pairsWith.name.replace(/^Add (a |an )?/i, '').replace(/^Consider /i, '').replace(/ later$/i, '') : '';
      const bookHref = rec.bookingUrl || TREATMENT_BOOK[rec.treatment] || BOOK_LINKS.skinAnalysis;
      const heroTitleClass = rec.name.trim().split(/\s+/).length === 1 ? ' heroNameSingle' : '';
      // Keep the visible action consistent with the live service pages. When a
      // provider confirmation is required, the link still goes to Skin
      // Analysis and the accessible label explains the consult destination.
      const bookLabel = 'Book Now';
      const bookAria = rec.requiresConsult ? 'Book a consultation for ' + rec.name : 'Book ' + rec.name + ' now';
      return '<section class="result animate" key="result">' +
        '<header class="hero"><figure class="heroImage"' + styleBg(rec.heroImage) + ' aria-hidden="true"><figcaption class="heroTag"><span class="heroTagDot" aria-hidden="true"></span>King West · Toronto</figcaption></figure>' +
          '<div class="heroBody"><span class="revealEyebrow">Your Match</span><h1 class="heroName' + heroTitleClass + '">' + escapeHtml(rec.name) + '</h1><p class="heroTagline">' + escapeHtml(rec.tagline) + '</p>' +
            '<div class="heroMeta"><div class="heroMetaRow"><span class="heroMetaLabel">Duration</span><div class="heroMetaValue">' + metaStack(rec.duration, 'duration') + '</div></div><div class="heroMetaRow"><span class="heroMetaLabel">Investment</span><div class="heroMetaValue">' + metaStack(rec.priceLine, 'price') + '</div></div></div>' +
            (rec.priceNote ? '<p class="priceNote">' + escapeHtml(rec.priceNote) + '</p>' : '') +
            '<div class="heroActions"><a href="' + escapeHtml(bookHref) + '" class="toula-button" aria-label="' + escapeHtml(bookAria) + '">' + bookLabel + '</a></div>' +
            '<p class="heroIncentive"><span class="heroIncentiveDot" aria-hidden="true"></span>4.9 ★ · 100+ Google reviews · King West</p>' +
            '<div class="reasonsBlock"><span class="reasonsLabel">Why this fits you</span><ul class="reasons">' + rec.reasonBullets.slice(0, 3).map((bullet) => '<li class="reason">' + escapeHtml(bullet) + '</li>').join('') + '</ul></div>' +
            (rec.requiresConsult ? '<p class="resultDisclaimer">' + escapeHtml(rec.consultReason) + '</p>' : '') +
          '</div></header>' +
        '<section class="secPad ruled includedSection"><div class="wrap includedGrid"><header class="sectionHeader"><span class="sectionEyebrow">What&apos;s Included</span><h3 class="sectionTitle">What the visit feels like.</h3></header><div class="included">' + rec.included.map((step) => '<div class="includedCard"><span class="includedStep">' + escapeHtml(step.step) + '</span><div><h4 class="includedTitle">' + escapeHtml(step.title) + '</h4><p class="includedBody">' + escapeHtml(step.body) + '</p></div></div>').join('') + '</div></div></section>' +
        '<section class="secPad ruled ruledHair"><div class="wrap providerGrid"><figure class="providerPortrait"' + styleBg(TEAM_IMAGE) + ' aria-hidden="true"></figure><div class="providerBody"><span class="revealEyebrow">Your Care Team</span><h3 class="providerName">One team, start to finish.</h3><p class="providerBlurb">At TOULA, your treatment is in the hands of a team of medical estheticians and registered nurse injectors. It’s the same team behind our 4.9 stars across 100+ Google reviews.</p><div class="providerRule" aria-hidden="true"></div></div></div></section>' +
        '<section class="secPad ruled ruledHair"><div class="wrap"><figure class="testimonial"><span class="sectionEyebrow sectionEyebrowCenter">Heard at TOULA</span><div class="testimonialStars" aria-label="Five stars">★★★★★</div><span class="testimonialMark" aria-hidden="true">&ldquo;</span><blockquote class="testimonialQuote">' + escapeHtml(rec.testimonial.quote) + '</blockquote><figcaption class="testimonialAttribution">' + escapeHtml(rec.testimonial.attribution) + '</figcaption></figure></div></section>' +
        renderMembershipBenefits(rec) +
        (rec.showMicroneedlingAddon ? renderMicroneedlingAddon() : '') +
        (rec.family === 'facial' ? renderFacialAddons() : (rec.pairsWith && !(rec.showMicroneedlingAddon && /microneedling/i.test(rec.pairsWith.name)) ? '<section class="secPad" style="padding-top: 0"><div class="wrap"><div class="pairsWith"><figure class="pairsImage"' + styleBg(rec.pairsWith.image) + ' aria-hidden="true"></figure><div class="pairsBody"><span class="pairsLabel">Pairs Well With</span><h4 class="pairsName">' + escapeHtml(rec.pairsWith.name) + '</h4><p class="pairsBlurb">' + escapeHtml(rec.pairsWith.blurb) + '</p><div class="pairsCtaWrap"><a href="' + escapeHtml(rec.pairsWith.bookingUrl || BOOK_LINKS.skinAnalysis) + '" class="toula-button" aria-label="Book ' + escapeHtml(pairBookLabel) + '">Book Now</a></div></div></div></div></section>' : '')) +
        (rec.showInjectablesCallout ? renderInjectablesAddon() : '') +
        '<div class="wrap"><div class="resultFooter"><button type="button" class="controlButton" data-action="back-from-result">' + arrowIcon('left') + ' Edit my last answer</button><button type="button" class="controlButton controlPrimary" data-action="restart">Retake the quiz</button></div></div>' +
        '<div class="footmark"><img src="' + TOULA_LOGO + '" alt="TOULA" class="footmarkLogo" width="120" height="48"></div>' +
      '</section>';
    }

    function renderMembershipBenefits(rec) {
      const tier = rec.membership || MEMBERSHIP_TIERS[rec.treatment] || BEAUTY_BANK_TIER;
      const strong = (text) => '<strong>' + escapeHtml(text) + '</strong>';
      let eyebrow, title, lede, ctaLabel;
      if (tier.kind === 'facial') {
        // Personalized: leads with THEIR facial, names the alternate + price. Tier is in the title.
        eyebrow = 'Matched to Your Result';
        title = 'Get the ' + tier.tier + ' membership.';
        lede = tier.alternate
          ? '<span class="membershipLedeP">Your ' + escapeHtml(tier.facial) + ' every month, or alternate with ' + escapeHtml(tier.alternate) + '. Skin responds to consistency, so every visit picks up where the last left off.</span><span class="membershipLedeP">$' + tier.price + '/month. 3-Month Commitment.</span>'
          : '<span class="membershipLedeP">' + (/^the /i.test(tier.facial) ? escapeHtml(tier.facial) : 'Your ' + escapeHtml(tier.facial)) + ' every month. Skin responds to consistency, so every visit picks up where the last left off.</span><span class="membershipLedeP">$' + tier.price + '/month. 3-Month Commitment.</span>';
        ctaLabel = 'Start with ' + tier.tier;
      } else {
        // Beauty Bank membership — the real flexible-credit plan for treatments without a monthly-facial tier.
        eyebrow = 'Matched to Your Result';
        title = 'Get the Beauty Bank membership.';
        lede = '<span class="membershipLedeP">' + strong('Beauty Bank') + ' sets aside $' + tier.price + ' every month, stored toward any treatment or product, ready when you are.</span><span class="membershipLedeP">Spend it on ' + escapeHtml(rec.name) + ' now, or let it build toward something bigger. 3-Month Commitment.</span>';
        ctaLabel = 'Start Beauty Bank';
      }
      const skincarePct = tier.skincarePct || 10;
      // Three real member perks (verified from the live /pages/our-memberships page).
      const perks = [
        { title: 'Sign-Up Rewards', body: '1 Complimentary Express Facial for you or to gift a friend, 3 LED Light Therapy sessions to keep results building.' },
        { title: 'Member pricing', body: 'Exclusive member rates on every treatment and add-on, including injectables and microneedling.' },
        { title: 'Skincare savings', body: skincarePct + '% off all skincare, plus early access to sales and new launches.' },
      ];
      return '<section class="secPad ruled"><div class="wrap includedGrid"><header class="sectionHeader"><span class="sectionEyebrow">' + escapeHtml(eyebrow) + '</span><h3 class="sectionTitle">' + escapeHtml(title) + '</h3><p class="membershipLede">' + lede + '</p><div class="membershipCtaWrap membershipCtaWrapLede"><a href="' + escapeHtml(state.membershipUrl) + '" class="toula-button">' + escapeHtml(ctaLabel) + '</a></div></header><div class="included">' + perks.map((perk, i) => '<div class="includedCard"><span class="includedStep">' + escapeHtml(String(i + 1).padStart(2, '0')) + '</span><div><h4 class="includedTitle">' + escapeHtml(perk.title) + '</h4><p class="includedBody">' + escapeHtml(perk.body) + '</p></div></div>').join('') + '</div></div></section>';
    }

    function renderMicroneedlingAddon() {
      return '<section class="secPad ruled ruledHair"><div class="wrap"><div class="addon"><figure class="addonImage"' + styleBg(MICRONEEDLING_HERO) + ' aria-hidden="true"></figure><div class="addonBody"><span class="addonEyebrow">Open to microneedling?</span><h3 class="addonName">Add Advanced Microneedling</h3><p class="addonBlurb">Pair your plan with Dermapen 4 microneedling and a Serum Booster (Meso Glide) matched to your skin. A provider will confirm whether it is appropriate.</p><div class="addonCtaWrap"><a href="' + escapeHtml(BOOK_LINKS.skinAnalysis) + '" class="toula-button" aria-label="Book a consultation for Advanced Microneedling">Book Now</a></div></div></div></div></section>';
    }

    function renderFacialAddons() {
      const addons = [
        { name: 'Organic Sheet Mask', price: 'Drop-in $15 · Member $12' },
        { name: 'Dermaplaning', price: 'Drop-in $65 · Member $55' },
      ];
      return '<section class="secPad ruled ruledHair"><div class="wrap"><div class="facialAddons"><span class="addonEyebrow">Enhance your facial</span><h3 class="addonName">Make it yours</h3><div class="facialAddonList">' + addons.map((item) => '<div class="facialAddonRow"><span class="facialAddonName">' + escapeHtml(item.name) + '</span><span class="facialAddonPrice">' + escapeHtml(item.price) + '</span></div>').join('') + '</div></div></div></section>';
    }

    function renderInjectablesAddon() {
      return '<section class="secPad ruled ruledHair"><div class="wrap"><div class="addon"><figure class="addonImage"' + styleBg(IMG.botoxHero) + ' aria-hidden="true"></figure><div class="addonBody"><span class="addonEyebrow">Open to injectables?</span><h3 class="addonName">Explore injectables</h3><p class="addonBlurb">If you are curious, wrinkle relaxers soften expression lines and filler restores volume, both placed conservatively for a natural result. A provider will confirm whether it is right for you.</p><div class="addonCtaWrap"><a href="' + escapeHtml(BOOK_LINKS.injectablesConsult) + '" class="toula-button" aria-label="Book an injectables consultation">Book Now</a></div></div></div></div></section>';
    }

    function emitCompletion() {
      if (state.completionEmitted || !hasCompleteAnswers(state.answers)) return;
      const resultKey = recommend(state.answers).treatment;
      state.completionEmitted = true;
      window.dispatchEvent(new CustomEvent('toula:quiz-completed', {
        detail: { quizVersion: QUIZ_VERSION, resultKey }
      }));
    }

    function bind() {
      shell.querySelectorAll('[data-action="start"]').forEach((button) => button.addEventListener('click', () => {
        state.answers = {};
        state.step = 0;
        state.phase = "question";
        state.openDetailsId = null;
        state.completionEmitted = false;
        render();
        focusStageInteractive();
      }));
      shell.querySelectorAll('[data-action="restart"]').forEach((button) => button.addEventListener('click', () => {
        state.phase = "welcome";
        state.step = 0;
        state.answers = {};
        state.openDetailsId = null;
        state.completionEmitted = false;
        render();
        window.scrollTo({ top: 0, behavior: "smooth" });
        focusStageInteractive();
      }));
      shell.querySelectorAll('[data-action="back"]').forEach((button) => button.addEventListener('click', () => {
        if (state.step === 0) {
          state.phase = "welcome";
        } else {
          state.step = Math.max(0, state.step - 1);
          const q = QUESTIONS[state.step];
          if (q) delete state.answers[q.id];
        }
        state.openDetailsId = null;
        render();
        window.scrollTo({ top: 0, behavior: "smooth" });
        focusStageInteractive();
      }));
      shell.querySelectorAll('[data-action="back-from-result"]').forEach((button) => button.addEventListener('click', () => {
        state.phase = "question";
        state.step = QUESTIONS.length - 1;
        const q = QUESTIONS[state.step];
        if (q) delete state.answers[q.id];
        state.openDetailsId = null;
        state.completionEmitted = false;
        render();
        window.scrollTo({ top: 0, behavior: "smooth" });
        focusStageInteractive();
      }));
      shell.querySelectorAll('[data-action="answer"]').forEach((button) => button.addEventListener('click', (event) => {
        if (event.target && event.target.closest('[data-action="detail"], [data-action="close-detail"], [data-detail-overlay]')) return;
        if (state.advancing || state.openDetailsId) return;
        state.advancing = true;
        const question = QUESTIONS[state.step];
        state.answers = { ...state.answers, [question.id]: button.dataset.answer };
        // Update the selected state in place. Rebuilding the current cards here
        // replayed their entrance animation and caused the old double flash.
        const group = button.closest('[role="radiogroup"]') || button.parentNode;
        (group ? group.querySelectorAll('[data-action="answer"]') : [button]).forEach((card) => {
          const isSelected = card === button;
          card.classList.toggle('cardSelected', isSelected);
          card.setAttribute('aria-checked', isSelected ? 'true' : 'false');
        });
        window.setTimeout(() => {
          if (state.step + 1 >= QUESTIONS.length) {
            emitCompletion();
            state.phase = "result";
          } else {
            state.step += 1;
            const nextQuestion = QUESTIONS[state.step];
            if (nextQuestion) delete state.answers[nextQuestion.id];
          }
          state.openDetailsId = null;
          state.advancing = false;
          render();
          window.scrollTo({ top: 0, behavior: "smooth" });
          focusStageInteractive();
        }, ADVANCE_DELAY);
      }));
      shell.querySelectorAll('[data-action="detail"]').forEach((button) => {
        const toggle = () => {
          const answerId = button.dataset.answer;
          const isClosing = state.openDetailsId === answerId;
          state.openDetailsId = isClosing ? null : answerId;
          render();
          window.setTimeout(() => {
            if (isClosing) {
              findDetailTrigger(answerId)?.focus({ preventScroll: true });
            } else {
              shell.querySelector('[data-action="close-detail"]')?.focus({ preventScroll: true });
            }
          }, 0);
        };
        button.addEventListener('click', (event) => { event.stopPropagation(); toggle(); });
        button.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            event.stopPropagation();
            toggle();
          }
        });
      });
      shell.querySelectorAll('[data-action="close-detail"]').forEach((button) => button.addEventListener('click', (event) => {
        event.stopPropagation();
        closeDetailsAndRestoreFocus();
      }));
    }

    function focusStageInteractive() {
      window.setTimeout(() => {
        shell.querySelector('[data-action="answer"], [data-action="start"], [data-action="back-from-result"], .heroActions a')?.focus({ preventScroll: true });
      }, 0);
    }

    function findDetailTrigger(answerId) {
      return Array.from(shell.querySelectorAll('[data-action="detail"]'))
        .find((trigger) => trigger.dataset.answer === answerId);
    }

    function closeDetailsAndRestoreFocus() {
      const answerId = state.openDetailsId;
      state.openDetailsId = null;
      render();
      window.setTimeout(() => findDetailTrigger(answerId)?.focus({ preventScroll: true }), 0);
    }

    document.addEventListener('keydown', (event) => {
      if (!shell.contains(document.activeElement) && !state.openDetailsId) return;
      if (event.key === 'Escape' && state.openDetailsId) {
        event.preventDefault();
        closeDetailsAndRestoreFocus();
        return;
      }
      if (event.key === 'Tab' && state.openDetailsId) {
        const dialog = shell.querySelector('[data-detail-overlay]');
        const focusable = dialog ? Array.from(dialog.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')) : [];
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    });

    render();
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-toula-skin-quiz]").forEach(initQuiz);
  });
})();
